window.TABS.giftcard = (function () {
    return {
        statusCheckCount: 1,

        init: function () {
            document.getElementById('greeting').addEventListener('input', function (event) {
                TABS.giftcard.checkGreeting(event);
            });
        },

        changeAmount: function (e) {
            if (e.target.value === 'custom') {
                e.target.classList.add('d-none');
                document.querySelector('input[name=custom-amount]').classList.remove('d-none');
            }
        },
        showForm: function () {
            document.getElementById('payment-info').style.display = 'none';
            document.getElementById('buyer-info').style.display = 'block';
        },
        selectTemplate: function (e) {
            document.querySelectorAll('.template-wrapper').forEach(function (t) {
                t.classList.remove('bg-primary');
                t.querySelector('.template-title').style.opacity = 0;
                t.querySelector('.template-selected').classList.remove('template-selected', 'shadow');
                t.querySelector('img').classList.add('shadow-hover');
            });

            var selected = e.target.closest('.template-wrapper');
            selected.classList.add('bg-primary');
            selected.querySelector('.template-title').style.opacity = 1;
            selected.querySelector('img').classList.remove('shadow-hover');
            selected.querySelector('img').classList.add('template-selected', 'shadow');
        },
        selectTemplateInForm: function (event, id) {
            document.querySelectorAll('.template-pills .nav-link, .list-group .list-group-item.active').forEach(function (el) {
                el.classList.remove('active');
            });
            event.target.classList.add('active');
            document.querySelectorAll('#template-previews img').forEach(function (img) {
                img.classList.add('d-none');
            });
            document.querySelector('#template-previews [data-value="' + id + '"]').classList.remove('d-none');
            document.querySelector('input[name=template-id]').value = id;
        },
        checkGreeting: function (event) {
            var textarea = event.target;
            var textWithoutEmojis = textarea.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
            textarea.value = textWithoutEmojis;
        },
        showPayment: function (e) {
            var btn = e.target;
            if (btn.classList.contains('disabled')) {
                return;
            }
            this.clearError();
            btn.classList.add('disabled');
            btn.querySelector('.fa').classList.toggle('d-none');

            var data = new URLSearchParams(new FormData(btn.closest('form'))).toString();

            fetch('/api/v2/giftcard/validate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data
            }).then(response => response.json()).then(function (res) {
                if (res.success) {
                    document.getElementById('payment-info').innerHTML = res.html;
                    document.getElementById('buyer-info').style.display = 'none';
                    document.getElementById('payment-info').style.display = 'block';
                } else {
                    TABS.giftcard.showError(res.message);
                }
            }).catch(function (e) {
                console.error(e);
            }).finally(function () {
                btn.classList.remove('disabled');
                btn.querySelector('.fa').classList.toggle('d-none');
            });
        },
        sendVipps: function (e) {
            var btn = e.target;
            if (btn.classList.contains('disabled')) {
                return;
            }
            this.clearError();
            btn.classList.add('disabled');
            btn.querySelector('.fa').classList.toggle('d-none');

            var data = new URLSearchParams(new FormData(btn.closest('form'))).toString();

            fetch('/api/v2/giftcard/vipps', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data
            }).then(response => response.json()).then(function (res) {
                if (res.success) {
                    window.location = res.redirect;
                } else {
                    TABS.giftcard.showError(res.message);
                }
            }).catch(function () {
                TABS.giftcard.showError('Det skjedde noe galt. Prøv igjen senere.');
            }).finally(function () {
                btn.classList.remove('disabled');
                btn.querySelector('.fa').classList.toggle('d-none');
            });
        },
        clearError: function () {
            var alert = document.querySelector('#giftcard-form .alert.alert-danger');
            alert.textContent = '';
            alert.classList.add('d-none');
        },
        showError: function (error) {
            var alert = document.querySelector('#giftcard-form .alert.alert-danger');
            alert.textContent = error;
            alert.classList.remove('d-none');
        },
        checkStatus: function () {
            var token = document.querySelector('input[name=token]').value;
            var loader = document.querySelector('.loader');

            fetch('/api/v2/giftcard/status?t=' + token + '&attempt=' + TABS.giftcard.statusCheckCount)
                .then(response => response.json())
                .then(function (res) {
                    document.getElementById('status-title').textContent = res.title;
                    var statusIcon = document.getElementById('status-icon');
                    statusIcon.className = 'fa ' + res.icon;
                    document.getElementById('status-description').innerHTML = res.description;
                    if (res.try_again_btn) {
                        document.getElementById('try-again-button').classList.remove('d-none');
                    } else if (!res.inprogress) {
                        document.getElementById('home-button').classList.remove('d-none');
                    }
                    if (res.amount) {
                        document.getElementById('status-amount').textContent = 'Sum: ' + res.amount + ' kr';
                        document.getElementById('status-amount').classList.remove('d-none');
                    }

                    if (res.inprogress) {
                        TABS.giftcard.statusCheckCount++;
                        setTimeout(function () {
                            TABS.giftcard.checkStatus();
                        }, 1000);
                        return;
                    }

                })
                .catch(function (error) {
                    loader.remove();
                    document.getElementById('session-expired').classList.remove('d-none');
                });
        }
    }
})();
